import * as actionTypes from '../actions/actionTypes';

const cartObjects = localStorage.getItem("cartObjects")
    ? JSON.parse(localStorage.getItem("cartObjects"))
    : {
        worksWishList: [],
        itemsWishList: [],
        itemsCartList: [],
        itemsRentalList: [],
        itemsDateRangeObj: {},
        itemsDateObj: {},
        cartMsg: '',
        itemsShowsObj: {},
        cartReqObj: {},
        curBlocksObj: {}
    }

const INITIAL_STATE = {
    loading: false,
    cartObjects: { ...cartObjects, shopForm: null, showForm: null }
};

const CartReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.CART_UPDATE_CARTOBJECTS:
            return {
                loading: true
            }
        case actionTypes.CART_UPDATE_CARTOBJECTS_SUCCESS:
            let updatedObj = { ...state.cartObjects, ...action.payload };
            try {
                localStorage.setItem("cartObjects", JSON.stringify(updatedObj));
            }
            catch (err) { console.log("LOGS: localStorage err", err) }
            return {
                loading: false,
                cartObjects: updatedObj
            }
        case actionTypes.CART_SET_INITIAL_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default CartReducer;